<!-- Grid -->
<phscw-grid
  #gridClearingDisplay
  [gridId]="gridId"
  [simpleGrid]="true"
  [gridData]="gridData"
  [gridColumns]="gridColumns"
  [gridDisplayedColumns]="gridDisplayedColumns"
  [showAllRows]="showAllRows">
</phscw-grid>

<!-- Funktion um weitere Einträge zu laden -->
@if (!compareColumns) {
  <phscw-grid-load-more
    [gridId]="gridId"
    [enabled]="loadMoreEnabled"
    [visible]="loadMoreVisible"
    [gridPageCounter]="gridPage">
  </phscw-grid-load-more>
}

<!-- Ladeanimation -->
@if (compareColumns) {
  <div class="cw-flex-row">
    <div class="cw-grid-loading" [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
  </div>
}

<!-- Buttons Submit & Cancel -->
@if (compareColumns) {
  <div class="cw-button-wrapper">
    <div class="cw-button-wrapper">
      <button mat-raised-button color="primary" type="button" (click)="toggleRowsVisibility()">
        @if (showAllRows) {
          {{ 'SHARED.CLEARING.DISPLAY.HIDEROWS' | translate }}
          }@if (!showAllRows) {
          {{ 'SHARED.CLEARING.DISPLAY.SHOWROWS' | translate }}
        }
      </button>
    </div>
    <div class="cw-button-wrapper">
      <button mat-raised-button color="accent" type="button" [disabled]="loading || saving" (click)="clickSubmit()">
        {{ 'SHARED.CLEARING.DISPLAY.SAVE' | translate }}
        <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
      </button>
      <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
        {{ 'GENERAL.CANCEL' | translate }}
      </button>
    </div>
  </div>
}
